module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Tools/Brush-67b33b0c733d8d9991d8cd82ba6c1eae.svg";